import {http} from '../http'
import {APIResponse} from '../types'
import {handleError} from '../handleError'
import * as coreAuth from '../../coreApi/auth'

import {AuthClient} from '../../../types'

type ResolvedReturn = APIResponse<AuthClient[]>

export interface ListAuthClients {
  (accessToken: string): Promise<ResolvedReturn>
}

const ERROR_PATH = 'api.auth.listAuthClients()'

export const listAuthClients: ListAuthClients = async (accessToken) => {
  try {
    const response = await coreAuth.listAuthClients(http, accessToken)

    return Promise.resolve({
      result: 'success',
      data: response.data.Clients.map((client) => ({
        id: client.ID.toString(),
        name: client.Name,
        domainName: client.DomainName,
      })),
    })
  } catch (e) {
    let message = ''
    if (e instanceof Error) {
      message = e && e.message ? e.message : e.toString()
    }
    const result = handleError(ERROR_PATH, message, e)
    return Promise.resolve(result)
  }
}
